import { Fragment, useEffect, useRef, useState } from 'react';
import './Dashboard.scss';
import { useSelector } from 'react-redux';
import Worker from 'web-worker';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faListNumeric, faPrint, faRefresh, faTableCells, faTimes } from '@fortawesome/free-solid-svg-icons';

let worker;

const Dashboard = (props) => {
  const [predictionStarted, setPredictionStarted] = useState(false);
  const [result, setResult] = useState(null);
  const [emulationResult, setEmulationResult] = useState(null);
  const [calculating, setCalculating] = useState(false);
  const [predictionListPage, setPredictionListPage] = useState(0);
  const [predictionListItemsPerPage, setPredictionListItemsPerPage] = useState(5);
  const [selectedPrediction, setSelectedPrediction] = useState(-1);
  const [isPositionsWindowOpen, setIsPositionsWindowOpen] = useState(false);
  const [isNumbersWindowOpen, setIsNumbersWindowOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(-1);
  const [selectedNumber, setSelectedNumber] = useState(-1);
  const [fixedPositions, setFixedPositions] = useState([-1, -1, -1, -1, -1]);
  const [fixedPositionsChanged, setFixedPositionsChanged] = useState(false);
  const [fixedNumbersChanged, setFixedNumbersChanged] = useState(false);
  const [showInfo, setShowInfo] = useState(true);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [highlightedPositionSocket, setHighlightedPositionSocket] = useState(-1);
  const [highlightedNumberSocket, setHighlightedNumberSocket] = useState(-1);
  const [useLimit, setUseLimit] = useState(true);
  const [tabSelected, setTabSelected] = useState('positions');
  const [fixedNumbers, setFixedNumbers] = useState([-1, -1, -1, -1, -1]);
  const [simulating, setSimulating] = useState(false);
  const [rulesWhiteNumbersSelected, setRulesWhiteNumbersSelected] = useState([]);
  const [rulesCommonWhiteNumbersSelected, setRulesCommonWhiteNumbersSelected] = useState([]);
  const [rulesWhiteIdenticalsSelected, setRulesWhiteIdenticalsSelected] = useState([]);
  const [rulesWhiteNumbersFrom, setRulesWhiteNumbersFrom] = useState(parseInt(localStorage.getItem('rules-white-numbers-from')) || 0);
  const [rulesCommonWhiteNumbersFrom, setRulesCommonWhiteNumbersFrom] = useState(parseInt(localStorage.getItem('rules-common-white-numbers-from')) || 0);
  const [rulesWhiteIdenticalsFrom, setRulesWhiteIdenticalsFrom] = useState(parseInt(localStorage.getItem('rules-white-identicals-from')) || 0);
  const [rulesWhiteNumbersTo, setRulesWhiteNumbersTo] = useState(parseInt(localStorage.getItem('rules-white-numbers-to')) || 5);
  const [rulesCommonWhiteNumbersTo, setRulesCommonWhiteNumbersTo] = useState(parseInt(localStorage.getItem('rules-common-white-numbers-to')) || 5);
  const [rulesWhiteIdenticalsTo, setRulesWhiteIdenticalsTo] = useState(parseInt(localStorage.getItem('rules-white-identicals-to')) || 5);
  const [fives, setFives] = useState([]);
  const [simulatingProgress, setSimulatingProgress] = useState(0);
  const [drawsYears, setDrawsYears] = useState([]);
  const [simulationYear, setSimulationYear] = useState(parseInt(localStorage.getItem('simulation-year')) || 2017);
  const [rulesIgnoreDoublePositions, setRulesIgnoreDoublePositions] = useState(parseInt(localStorage.getItem('rules-ignore-double-positions')) || false);
  const [rulesChanged, setRulesChanged] = useState(false);
  const [numberExceptions, setNumberExceptions] = useState([]);
  const [showSuccessRateWindow, setShowSuccessRateWindow] = useState(false);
  const [winningDraw, setWinningDraw] = useState([]);
  const [successRate, setSuccessRate] = useState({
    5: 0,
    4: 0,
    3: 0,
    2: 0,
    1: 0,
  });

  const positionsWindowElRef = useRef(null);
  const numbersWindowElRef = useRef(null);

  const draws = useSelector((state) => state.app.data);

  useEffect(() => {
    worker = new Worker(
      new URL('../../prediction-worker.js', import.meta.url),
      { type: 'module' }
    );

    worker.onmessage = (e) => {
      // const r = e.data.predictionResult || e.data;
      // console.log(r)
      // r.plays = shuffleWithSeed(r.plays.slice(), 'ariadne');
      
      // r.plays.forEach((play) => {
      //   var uniqueDistances = [];

      //   for (var p = 0; p < play.length; p++) {
      //     if (uniqueDistances.indexOf(play[p]) === -1) {
      //       uniqueDistances.push(play[p]);
      //     }
      //   }

      //   play.uniqueDistances = uniqueDistances;
      // });

      // r.plays.sort((a, b) => {
      //   if (a.uniqueDistances.length > b.uniqueDistances.length) {
      //     return -1;
      //   } else if (a.uniqueDistances.length < b.uniqueDistances.length) {
      //     return 1;
      //   } else {
      //     return 0;
      //   }
      // });

      // setResult(r);
      
      if (e.data.type === 'pre-result') {
        setResult(e.data);
        setCalculating(false);
      } else if (e.data.type === 'final') {
        setEmulationResult(e.data.result);
        setShowInfo(true);
        setSimulating(false);
        setSimulatingProgress(0);
      }

      if (e.data.type !== 'info') {
        console.log(e.data);
      }

      if (e.data.type === 'info') {
        let progress = 0;

        // if (e.data.step === 1) {
        //   progress = (e.data.progress * 50) / 100;
        // } else if (e.data.step === 2) {
        //   progress = 50 + ((e.data.progress * 50) / 100);
        // }

        setSimulatingProgress(e.data.progress);
      }
    };

    return () => {
      if (worker) {
        worker.terminate();
      }
    };
  }, []);

  const onWindowClick = function(e) {
    if (positionsWindowElRef.current.contains(e.target) && !positionsWindowElRef.current.querySelector('.content').contains(e.target)) {
      setIsPositionsWindowOpen(false);
    }
    
    if (numbersWindowElRef.current.contains(e.target) && !numbersWindowElRef.current.querySelector('.content').contains(e.target)) {
      setIsNumbersWindowOpen(false);
    }
  };

  useEffect(() => {
    if (numbersWindowElRef.current) {
      window.addEventListener('click', onWindowClick);
    }
  }, [numbersWindowElRef]);

  useEffect(() => {
    
    return () => {
      window.removeEventListener('click', onWindowClick);
    };
  }, []);

  useEffect(() => {
    if (draws.length > 0) {
      predict();
    }
  }, [useLimit]);

  useEffect(() => {
    if (draws.length > 0) {
      predict();

      const years = [];

      draws.forEach((draw) => {
        const year = moment(draw.date).format('YYYY');

        if (years.indexOf(year) === -1) {
          years.push(year);
        }
      });

      setDrawsYears(years);
    }
  }, [draws]);

  useEffect(() => {
    setPredictionListPage(0);
    setSelectedPrediction(-1);
  }, [tabSelected]);

  useEffect(() => {
    if (result && result.fives) {
      const fives = result.fives;
      
      setFives(fives);
      setSelectedPrediction(-1);
      setPredictionListPage(0);
    }
  }, [
    result,
  ]);

  useEffect(() => {
    setRulesChanged(true);
  }, [
    rulesWhiteNumbersSelected,
    rulesCommonWhiteNumbersSelected,
    rulesWhiteIdenticalsSelected,
    rulesWhiteNumbersFrom,
    rulesWhiteNumbersTo,
    rulesCommonWhiteNumbersFrom,
    rulesCommonWhiteNumbersTo,
    rulesWhiteIdenticalsFrom,
    rulesWhiteIdenticalsTo,
    rulesIgnoreDoublePositions,
    simulationYear,
  ]);

  function predict() {
    if (calculating || simulating) {
      return false;
    }
    
    setPredictionStarted(true);
    setCalculating(true);
    setSimulating(true);
    setFixedPositionsChanged(false);
    setFixedNumbersChanged(false);
    setShowInfo(false);
    setSelectedPrediction(-1);
    setRulesChanged(false);

    worker.postMessage({
      draws,
      fixedPositions,
      fixedNumbers,
      useLimit,
      rules: {
        rulesIgnoreDoublePositions,
        simulationYear,
        rulesWhiteNumbersSelected,
        rulesCommonWhiteNumbersSelected,
        rulesWhiteIdenticalsSelected,
        rulesWhiteNumbersFrom,
        rulesWhiteNumbersTo,
        rulesCommonWhiteNumbersFrom,
        rulesCommonWhiteNumbersTo,
        rulesWhiteIdenticalsFrom,
        rulesWhiteIdenticalsTo,
      },
    });
  }

  function showMorePredictions() {
    let items = result.plays;

    if (tabSelected === 'fives') {
      items = fives;
    }

    if ((predictionListPage + 1) * predictionListItemsPerPage < items.length) {
      setPredictionListPage(predictionListPage + 1);
    } else {
      setPredictionListPage(0);
    }
  }

  function showTable() {
    setIsTableVisible(true);
  }

  return (
    <div className="Dashboard">
      <div className={`loading-window ${calculating ? '' : 'd-none'}`}>
        <FontAwesomeIcon icon={faCircleNotch} size="2x" spin></FontAwesomeIcon>
      </div>
      
      <div className={`tab positions ${tabSelected !== 'positions' ? 'd-none' : ''}`}>
        <div style={{ display: 'flex', position: 'relative' }}>

          <div className={`limit-toggle ${predictionStarted && result ? '' : 'hidden'}`} style={{ opacity: simulating ? '0.25' : '1' }}>
            <span>Όριο</span>

            <label className={`switch`}>
              <input type="checkbox" checked={useLimit} onChange={(e) => {
                  if (!simulating) {
                    setUseLimit(e.target.checked);
                  }
                }}
              />
              <span className="slider round"></span>
            </label>
          </div>

          <div className={`positions ${predictionStarted && result ? '' : 'd-none'}`}>
            <div
              className={`${fixedPositions[0] > -1 ? 'fixed' : ''}`}
              onClick={() => {
                setSelectedPosition(0);
                setIsPositionsWindowOpen(true);
              }}
              onMouseOver={() => setHighlightedPositionSocket(0)}
              onMouseOut={() => {
                setHighlightedPositionSocket(-1);
              }}
            >
              {
                fixedPositions[0] === -1 && selectedPrediction > -1 && <span>{result.plays[selectedPrediction - 1][0] + 1}</span>
              }
              {
                fixedPositions[0] > -1 && <span>{fixedPositions[0] + 1}</span>
              }
            </div>
            
            <div
              className={`${fixedPositions[1] > -1 ? 'fixed' : ''}`}
              onClick={() => {
                setSelectedPosition(1);
                setIsPositionsWindowOpen(true);
              }}
              onMouseOver={() => setHighlightedPositionSocket(1)}
              onMouseOut={() => {
                setHighlightedPositionSocket(-1);
              }}
            >
              {
                fixedPositions[1] === -1 && selectedPrediction > -1 && <span>{result.plays[selectedPrediction - 1][1] + 1}</span>
              }
              {
                fixedPositions[1] > -1 && <span>{fixedPositions[1] + 1}</span>
              }
            </div>
            
            <div
              className={`${fixedPositions[2] > -1 ? 'fixed' : ''}`}
              onClick={() => {
                setSelectedPosition(2);
                setIsPositionsWindowOpen(true);
              }}
              onMouseOver={() => setHighlightedPositionSocket(2)}
              onMouseOut={() => {
                setHighlightedPositionSocket(-1);
              }}
            >
              {
                fixedPositions[2] === -1 && selectedPrediction > -1 && <span>{result.plays[selectedPrediction - 1][2] + 1}</span>
              }
              {
                fixedPositions[2] > -1 && <span>{fixedPositions[2] + 1}</span>
              }
            </div>
            
            <div
              className={`${fixedPositions[3] > -1 ? 'fixed' : ''}`}
              onClick={() => {
                setSelectedPosition(3);
                setIsPositionsWindowOpen(true);
              }}
              onMouseOver={() => setHighlightedPositionSocket(3)}
              onMouseOut={() => {
                setHighlightedPositionSocket(-1);
              }}
            >
              {
                fixedPositions[3] === -1 && selectedPrediction > -1 && <span>{result.plays[selectedPrediction - 1][3] + 1}</span>
              }
              {
                fixedPositions[3] > -1 && <span>{fixedPositions[3] + 1}</span>
              }
            </div>
            
            <div
              className={`${fixedPositions[4] > -1 ? 'fixed' : ''}`}
              onClick={() => {
                setSelectedPosition(4);
                setIsPositionsWindowOpen(true);
              }}
              onMouseOver={() => setHighlightedPositionSocket(4)}
              onMouseOut={() => {
                setHighlightedPositionSocket(-1);
              }}
            >
              {
                fixedPositions[4] === -1 && selectedPrediction > -1 && <span>{result.plays[selectedPrediction - 1][4] + 1}</span>
              }
              {
                fixedPositions[4] > -1 && <span>{fixedPositions[4] + 1}</span>
              }
            </div>
            
            <div className="bonus"></div>
          </div>

          <button className={`btn-recalculate ${fixedPositionsChanged && predictionStarted ? '' : 'hidden'}`} onClick={predict} style={{marginLeft: '20px', border: 'none', background: 'none', cursor: 'pointer', color: '#008fe9'}}>
            <FontAwesomeIcon icon={faRefresh} size="2x"></FontAwesomeIcon>
          </button>
        </div>

        <div className={`prediction-list ${predictionStarted && !isTableVisible ? '' : 'd-none'}`}>
          {
            result && result.plays && result.plays.slice(predictionListPage * predictionListItemsPerPage, (predictionListPage + 1) * predictionListItemsPerPage).map((column, i) => {
              return (
                <div
                  key={i}
                  className={`prediction-item ${selectedPrediction === (predictionListPage * predictionListItemsPerPage) + i + 1 ? 'selected' : ''}`}
                  onClick={() => {
                    if (selectedPrediction === (predictionListPage * predictionListItemsPerPage) + i + 1) {
                      setSelectedPrediction(-1);
                    } else {
                      setSelectedPrediction((predictionListPage * predictionListItemsPerPage) + i + 1);
                    }
                  }}
                >
                  <div className="number">
                    <span className="hash">#</span>
                    <span>{(predictionListPage * predictionListItemsPerPage) + i + 1}</span>
                  </div>

                  <div className="numbers">
                    {
                      column.map((position, j) => {
                        return (
                          <span
                            key={j}
                            className={``}
                          >
                            {position + 1}
                          </span>
                        );
                      })
                    }
                  </div>
                </div>
              );
            })
          }
        </div>

        <div className={`table ${predictionStarted && isTableVisible ? '' : 'd-none'}`}>
          <table>
            <thead>
              <tr>
                <th>Θέση/<br />Απόσταση</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
                <th>8</th>
                <th>9</th>
                <th>10</th>
              </tr>
            </thead>
            
            <tbody>
              {
                Array.from(Array(25)).map((n, i) => {
                  return (
                    <tr
                      key={i}
                    >
                      <td>{i + 1}</td>
                      {
                        result && result.currentDistances && Array.from(Array(10)).map((N, j) => {
                          let numbers = [];

                          for (let d = 0; d < result.currentDistances.length; d++) {
                            let highlightedPosition = -1;

                            if (highlightedPositionSocket > -1) {
                              if (fixedPositions[highlightedPositionSocket] > -1) {
                                highlightedPosition = fixedPositions[highlightedPositionSocket];
                              } else if (selectedPrediction > -1) {
                                highlightedPosition = result.plays[selectedPrediction - 1][highlightedPositionSocket];
                              }
                            }

                            const cd = result.currentDistances[d];
                            
                            if (cd.distance === i && ((cd.value.toString().slice(-1)[0] === (j + 1).toString()) || cd.value.toString().slice(-1)[0] === '0' && j + 1 === 10)) {
                              numbers.push(<span key={d} className={`${highlightedPosition === cd.distance ? 'highlighted' : ''} ${result.table.whiteNumbers.includes(cd.value) ? 'white-number' : ''}`}>{cd.value}</span>);
                            }
                          }

                          if (numbers.length === 0) {
                            numbers.push((<span key={1}>&nbsp;</span>))
                          }

                          return (
                            <td
                              key={j}
                            >
                              <div>
                                {numbers}
                              </div>
                            </td>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }

              <tr>
                <td>25+</td>
                {
                  result && result.currentDistances && Array.from(Array(10)).map((N, j) => {
                    let numbers = [];

                    for (let d = 0; d < result.currentDistances.length; d++) {
                      let highlightedPosition = -1;

                      if (highlightedPositionSocket > -1) {
                        if (fixedPositions[highlightedPositionSocket] > -1) {
                          highlightedPosition = fixedPositions[highlightedPositionSocket];
                        } else if (selectedPrediction > -1) {
                          highlightedPosition = result.plays[selectedPrediction - 1][highlightedPositionSocket];
                        }
                      }

                      const cd = result.currentDistances[d];
                      
                      if (cd.distance > 25 && cd.distance <= 35 && ((cd.value.toString().slice(-1)[0] === (j + 1).toString()) || cd.value.toString().slice(-1)[0] === '0' && j + 1 === 10)) {
                        numbers.push(<span key={d} className={`${highlightedPosition === cd.distance ? 'highlighted' : ''}`}>{cd.value}</span>);
                      }
                    }

                    if (numbers.length === 0) {
                      numbers.push((<span key={1}>&nbsp;</span>))
                    }

                    return (
                      <td
                        key={j}
                      >
                        <div>
                          {numbers}
                        </div>
                      </td>
                    );
                  })
                }
              </tr>

              <tr>
                <td>35+</td>
                {
                  result && result.currentDistances && Array.from(Array(10)).map((N, j) => {
                    let numbers = [];

                    for (let d = 0; d < result.currentDistances.length; d++) {
                      let highlightedPosition = -1;

                      if (highlightedPositionSocket > -1) {
                        if (fixedPositions[highlightedPositionSocket] > -1) {
                          highlightedPosition = fixedPositions[highlightedPositionSocket];
                        } else if (selectedPrediction > -1) {
                          highlightedPosition = result.plays[selectedPrediction - 1][highlightedPositionSocket];
                        }
                      }

                      const cd = result.currentDistances[d];
                      
                      if (cd.distance > 35 && ((cd.value.toString().slice(-1)[0] === (j + 1).toString()) || cd.value.toString().slice(-1)[0] === '0' && j + 1 === 10)) {
                        numbers.push(<span key={d} className={`${highlightedPosition === cd.distance ? 'highlighted' : ''}`}>{cd.value}</span>);
                      }
                    }

                    if (numbers.length === 0) {
                      numbers.push((<span key={1}>&nbsp;</span>))
                    }

                    return (
                      <td
                        key={j}
                      >
                        <div>
                          {numbers}
                        </div>
                      </td>
                    );
                  })
                }
              </tr>
            </tbody>
          </table>
        </div>

        <button className={`btn-show-more-predictions ${predictionStarted && result && result.plays && result.plays.length && result.plays.length > 5 && !isTableVisible ? '' : 'd-none'}`} onClick={showMorePredictions}>Περισσότερες προτάσεις</button>

        <button className={`btn-show-table ${predictionStarted && result && !isTableVisible ? '' : 'd-none'}`} onClick={showTable}>
          <FontAwesomeIcon icon={faTableCells} size="lg"></FontAwesomeIcon>
          <span style={{marginLeft: '5px'}}>Εκτύπωση</span>
        </button>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <button
            className={`btn-show-prediction-list ${predictionStarted && isTableVisible ? '' : 'd-none'}`}
            onClick={() => {
              setIsTableVisible(false);
            }}
          >
            <FontAwesomeIcon icon={faListNumeric} size="lg"></FontAwesomeIcon>
            <span style={{marginLeft: '5px'}}>Προτάσεις</span>
          </button>

          <button
            className={`btn-print ${predictionStarted && isTableVisible ? '' : 'd-none'}`}
            style={{ marginLeft: '20px' }}
            onClick={() => {
              window.print();
            }}
          >
            <FontAwesomeIcon icon={faPrint} size="lg"></FontAwesomeIcon>
            <span style={{ marginLeft: '5px' }}>Εκτύπωση A4</span>
          </button>
        </div>

        <div
          className={`d-none console ${showInfo && predictionStarted ? '' : 'd-none'}`}
        >
          <button
            className="btn-close"
            onClick={() => {
              setShowInfo(false);
            }}
          >
            Κλείσιμο
          </button>

          {
            result && fixedPositions.filter((fp) => fp > -1).length < 5 && <p>
              {
                fixedPositions.filter((fp) => fp > -1).length > 0
                  ? <span>Με {fixedPositions.filter((fp) => fp > -1).length} standard θέσεις</span>
                  : <span>Χωρίς κάποια standard θέση</span>
              }
              , οι προτάσεις για την επόμενη κλήρωση έχουν ποσοστό επιτυχίας {result.successRate} ή {result.successRateAlt}.
              Ο μέσος όρος προτάσεων για κάθε κλήρωση είναι {result.averagePlays}, και χρειάζονται περίπου {result.playsUntilWin} στήλες για μια πιθανή επιτυχία.
              <br />
              <small>Με {fixedPositions.filter((fp) => fp > -1).length > 0 ? 'ακόμα' : ''} μία standard θέση (από δεξιά), αυξάνεται το ποσοστό επιτυχίας στο {result.nextFixedPositionSuccessRate} ή {result.nextFixedPositionSuccessRateAlt}.</small>
            </p>
          }
        </div>

        <div
          className={`positions-window ${isPositionsWindowOpen ? '' : 'd-none'}`}
          ref={positionsWindowElRef}
        >
          <div className="content">
            {
              result && result.currentDistances && result.currentDistances.map((d) => d.distance).filter((d, i) => result.currentDistances.map((d) => d.distance).indexOf(d) === i).map((p, i) => {
                if (useLimit && (p < 2 || p > 24)) {
                  return;
                }

                for (let j = 0; j < selectedPosition; j++) {
                  let filledPosition = fixedPositions[j];

                  if (filledPosition === -1 && selectedPrediction > -1) {
                    filledPosition = result.plays[selectedPrediction - 1][j];
                  }

                  if (p < filledPosition || fixedPositions.indexOf(p) > -1) {
                    return;
                  }
                }

                return (
                  <span
                    key={i}
                    onClick={() => {
                      const fp = fixedPositions;
                      
                      fp[selectedPosition] = p;
                      
                      setFixedPositions(fp);
                      setFixedPositionsChanged(true);
                      setIsPositionsWindowOpen(false);
                    }}
                  >
                    {p + 1}
                  </span>
                );
              })
            }

            <span
              onClick={() => {
                const fp = fixedPositions;
                      
                fp[selectedPosition] = -1;
                
                setFixedPositions(fp);
                setFixedPositionsChanged(true);
                setIsPositionsWindowOpen(false);
              }}
            >
            </span>
          </div>
        </div>
      </div>

      <div className={`tab fives ${tabSelected !== 'fives' ? 'd-none' : ''}`}>
        <div className={`fives ${predictionStarted && result ? '' : 'd-none'}`}>
          <div
            className={`${fixedNumbers[0] > -1 ? 'fixed' : ''}`}
            onClick={() => {
              setSelectedNumber(0);
              setIsNumbersWindowOpen(true);
            }}
            onMouseOver={() => setHighlightedNumberSocket(0)}
            onMouseOut={() => {
              setHighlightedNumberSocket(-1);
            }}
          >
            {
              fixedNumbers[0] === -1 && selectedPrediction > -1 && <span>{fives[selectedPrediction - 1][0]}</span>
            }
            {
              fixedNumbers[0] > -1 && <span>{fixedNumbers[0]}</span>
            }
          </div>
          
          <div
            className={`${fixedNumbers[1] > -1 ? 'fixed' : ''}`}
            onClick={() => {
              setSelectedNumber(1);
              setIsNumbersWindowOpen(true);
            }}
            onMouseOver={() => setHighlightedNumberSocket(1)}
            onMouseOut={() => {
              setHighlightedNumberSocket(-1);
            }}
          >
            {
              fixedNumbers[1] === -1 && selectedPrediction > -1 && <span>{fives[selectedPrediction - 1][1]}</span>
            }
            {
              fixedNumbers[1] > -1 && <span>{fixedNumbers[1]}</span>
            }
          </div>
          
          <div
            className={`${fixedNumbers[2] > -1 ? 'fixed' : ''}`}
            onClick={() => {
              setSelectedNumber(2);
              setIsNumbersWindowOpen(true);
            }}
            onMouseOver={() => setHighlightedNumberSocket(2)}
            onMouseOut={() => {
              setHighlightedNumberSocket(-1);
            }}
          >
            {
              fixedNumbers[2] === -1 && selectedPrediction > -1 && <span>{fives[selectedPrediction - 1][2]}</span>
            }
            {
              fixedNumbers[2] > -1 && <span>{fixedNumbers[2]}</span>
            }
          </div>
          
          <div
            className={`${fixedNumbers[3] > -1 ? 'fixed' : ''}`}
            onClick={() => {
              setSelectedNumber(3);
              setIsNumbersWindowOpen(true);
            }}
            onMouseOver={() => setHighlightedNumberSocket(3)}
            onMouseOut={() => {
              setHighlightedNumberSocket(-1);
            }}
          >
            {
              fixedNumbers[3] === -1 && selectedPrediction > -1 && <span>{fives[selectedPrediction - 1][3]}</span>
            }
            {
              fixedNumbers[3] > -1 && <span>{fixedNumbers[3]}</span>
            }
          </div>
          
          <div
            className={`${fixedNumbers[4] > -1 ? 'fixed' : ''}`}
            onClick={() => {
              setSelectedNumber(4);
              setIsNumbersWindowOpen(true);
            }}
            onMouseOver={() => setHighlightedNumberSocket(4)}
            onMouseOut={() => {
              setHighlightedNumberSocket(-1);
            }}
          >
            {
              fixedNumbers[4] === -1 && selectedPrediction > -1 && <span>{fives[selectedPrediction - 1][4]}</span>
            }
            {
              fixedNumbers[4] > -1 && <span>{fixedNumbers[4]}</span>
            }
          </div>
          
          <div className="bonus"></div>
        </div>

        {/* <div className="exceptions">
          <span>Εξαιρέσεις Αριθμών</span>
          <small>Πατήστε για εξαίρεση του επιλεγμένου αριθμού</small>

          <div className="numbers">
            {
              result && result.table && Array.from(Array(45)).map((n, i) => {
                return (
                  <span
                    key={i}
                    className={`${numberExceptions.includes(i +1) ? 'active' : ''}`}
                    onClick={() => {
                      const ne = numberExceptions.slice();

                      if (ne.includes(i +1)) {
                        ne.splice(ne.indexOf(i + 1), 1);
                      } else {
                        ne.push(i + 1);
                      }

                      setNumberExceptions(ne);
                    }}
                  >
                    {i + 1}
                  </span>
                );
              })
            }
          </div>
        </div> */}

        <div className={`prediction-list ${predictionStarted ? '' : 'd-none'}`}>
          {
            result && result.fives && fives.slice(predictionListPage * predictionListItemsPerPage, (predictionListPage + 1) * predictionListItemsPerPage).map((five, i) => {
              return (
                <div
                  key={i}
                  className={`prediction-item ${selectedPrediction === (predictionListPage * predictionListItemsPerPage) + i + 1 ? 'selected' : ''}`}
                  onClick={() => {
                    if (selectedPrediction === (predictionListPage * predictionListItemsPerPage) + i + 1) {
                      setSelectedPrediction(-1);
                    } else {
                      setSelectedPrediction((predictionListPage * predictionListItemsPerPage) + i + 1);
                    }
                  }}
                >
                  <div className="number">
                    <span className="hash">#</span>
                    <span>{(predictionListPage * predictionListItemsPerPage) + i + 1}</span>
                  </div>

                  <div className="numbers">
                    {
                      five.map((number, j) => {
                        return (
                          <span
                            key={j}
                            className={``}
                          >
                            {number}
                          </span>
                        );
                      })
                    }
                  </div>
                </div>
              );
            })
          }

          {result && result.fives && fives.length === 0 && <span>Δεν υπάρχουν προτάσεις. Ελέγξτε τους κανόνες σας.</span>}
        </div>

        <div className={`rules ${result ? '' : 'd-none'}`}>
          <div>
            <span>Λευκοί Αριθμοί</span>
            
            <div>
              <span>Περιέλαβε τουλάχιστον</span>
              <input type="number" min="0" max="5" value={rulesWhiteNumbersFrom} onChange={(e) => {
                setRulesWhiteNumbersFrom(e.target.value);

                localStorage.setItem('rules-white-numbers-from', e.target.value);
              }}></input>
              <span>λευκούς αριθμούς</span>
            </div>

            {/* <div>
              <span>Έως</span>
              <input type="number" min={rulesWhiteNumbersFrom} max="5" value={rulesWhiteNumbersTo} onChange={(e) => {
                setRulesWhiteNumbersTo(e.target.value);

                localStorage.setItem('rules-white-numbers-to', e.target.value);
              }}></input>
            </div> */}
            
            <div className="numbers">
              {
                result && result.table && result.table.whiteNumbers.sort((a, b) => a - b).map((n, i) => {
                  return (
                    <span
                      key={i}
                      className={`${rulesWhiteNumbersSelected.indexOf(n) > -1 ? 'active' : ''}`}
                      onClick={() => {
                        const rwns = rulesWhiteNumbersSelected.slice();

                        if (rulesWhiteNumbersSelected.indexOf(n) === -1) {
                          rwns.push(n);
                        } else {
                          rwns.splice(rwns.indexOf(n), 1);
                        }

                        setRulesWhiteNumbersSelected(rwns);
                      }}
                    >
                      {n}
                    </span>
                  );
                })
              }
            </div>
          </div>

          <div>
            <span>Κοινοί Λευκοί Αριθμοί</span>
            
            <div>
              <span>Περιέλαβε τουλάχιστον</span>
              <input type="number" min="0" max="5" value={rulesCommonWhiteNumbersFrom} onChange={(e) => {
                setRulesCommonWhiteNumbersFrom(e.target.value);

                localStorage.setItem('rules-common-white-numbers-from', e.target.value);
              }}></input>
              <span>κοινούς λευκούς</span>
            </div>

            {/* <div>
              <span>Έως</span>
              <input type="number" min={rulesCommonWhiteNumbersFrom} max="5" value={rulesCommonWhiteNumbersTo} onChange={(e) => {
                setRulesCommonWhiteNumbersTo(e.target.value);

                localStorage.setItem('rules-common-white-numbers-to', e.target.value);
              }}></input>
            </div> */}

            <div className="numbers">
              {
                result && result.table && result.table.commonWhiteNumbers.sort((a, b) => a - b).map((n, i) => {
                  return (
                    <span
                      key={i}
                      className={`${rulesCommonWhiteNumbersSelected.indexOf(n) > -1 ? 'active' : ''}`}
                      onClick={() => {
                        const rwns = rulesCommonWhiteNumbersSelected.slice();

                        if (rulesCommonWhiteNumbersSelected.indexOf(n) === -1) {
                          rwns.push(n);
                        } else {
                          rwns.splice(rwns.indexOf(n), 1);
                        }

                        setRulesCommonWhiteNumbersSelected(rwns);
                      }}
                    >
                      {n}
                    </span>
                  );
                })
              }
            </div>
          </div>

          <div>
            <span>Λευκοί Αριθμοί και Ταυτάριθμοι</span>
            
            <div>
              <span>Περιέλαβε τουλάχιστον</span>
              <input type="number" min="0" max="5" value={rulesWhiteIdenticalsFrom} onChange={(e) => {
                setRulesWhiteIdenticalsFrom(e.target.value);

                localStorage.setItem('rules-white-identicals-from', e.target.value);
              }}></input>
              <span>λευκούς ταυτάριθμους</span>
            </div>

            {/* <div>
              <span>Έως</span>
              <input type="number" min={rulesWhiteIdenticalsFrom} max="5" value={rulesWhiteIdenticalsTo} onChange={(e) => {
                setRulesWhiteIdenticalsTo(e.target.value);

                localStorage.setItem('rules-white-identicals-to', e.target.value);
              }}></input>
            </div> */}

            <div className="numbers">
              {
                result && result.table && result.table.whiteIdenticals.sort((a, b) => a - b).map((n, i) => {
                  return (
                    <span
                      key={i}
                      className={`${rulesWhiteIdenticalsSelected.indexOf(n) > -1 ? 'active' : ''}`}
                      onClick={() => {
                        const rwns = rulesWhiteIdenticalsSelected.slice();

                        if (rulesWhiteIdenticalsSelected.indexOf(n) === -1) {
                          rwns.push(n);
                        } else {
                          rwns.splice(rwns.indexOf(n), 1);
                        }

                        setRulesWhiteIdenticalsSelected(rwns);
                      }}
                    >
                      {n}
                    </span>
                  );
                })
              }
            </div>
          </div>

          <div>
            {/* <div>
              <span>Χρονολογία Προσομοίωσης</span>

              <select
                value={simulationYear}
                onChange={(e) => {
                  setSimulationYear(e.target.value);

                  localStorage.setItem('simulation-year', e.target.value);
                }}
              >
                {
                  drawsYears.map((year, i) => {
                    return <option key={i} value={year}>{year}</option>
                  })
                }
              </select>
            </div> */}

            <div>
              <span>Χωρίς διπλές θέσεις</span>

              <input type="checkbox" checked={rulesIgnoreDoublePositions} onChange={(e) => {
                setRulesIgnoreDoublePositions(e.target.checked);

                localStorage.setItem('rules-ignore-double-positions', e.target.checked ? 1 : 0);
              }}></input>
            </div>
          </div>
        </div>

        <button
          className={`button btn-show-more-predictions ${predictionStarted && result && fives.length > 5 ? '' : 'hidden'}`}
          onClick={showMorePredictions}
        >
          Περισσότερες προτάσεις
          &nbsp;
          {result && result.fives && <small>(από τις {fives.length})</small>}
        </button>

        <button
          className={`button btn-recalculate ${fixedNumbersChanged || rulesChanged || simulating ? '' : 'hidden'}`}
          onClick={() => {
            if (!simulating) {
              predict();
            }
          }}
        >
          {
            simulating
              ? <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                  <FontAwesomeIcon icon={faCircleNotch} spin></FontAwesomeIcon>
                  <span style={{ marginLeft: '5px' }}>Γίνεται προσομοίωση</span>
                </div>
              : 'Επαναυπολογισμός'
          }
        </button>

        <button className="button" onClick={() => setShowSuccessRateWindow(true)}>Επιτυχίες</button>

        <div className={`success-rate-window${showSuccessRateWindow ? '' : ' d-none'}`}>
          <FontAwesomeIcon icon={faTimes} size="2x" className="btn-close" onClick={() => setShowSuccessRateWindow(false)}></FontAwesomeIcon>
          
          <input
            type="text"
            placeholder="Νικητήρια στήλη (διαχωρισμός με κόμμα)"
            value={winningDraw}
            onChange={(e) => setWinningDraw(e.target.value)}
          />

          <button className="button" onClick={() => {
            const sr = {
              1: 0,
              2: 0,
              3: 0,
              4: 0,
              5: 0,
            };

            const winningNumbers = winningDraw.split(',');

            fives.forEach((five) => {
              let predicted = 0;

              for (let i = 0; i < winningNumbers.length; i++) {
                if (five.includes(parseInt(winningNumbers[i]))) {
                  predicted++;
                }
              }

              if (typeof sr[predicted] !== 'undefined') {
                sr[predicted] += 1;
              }
            });

            setSuccessRate(sr);
          }}>Εφαρμογή</button>

          <div className="results">
            <div className="draws">
              {
                showSuccessRateWindow && fives.map((five, i) => {
                  return (
                    <div
                      key={i}
                      className={`prediction-item`}
                    >
                      <div className="number">
                        <span className="hash">#</span>
                        <span>{i + 1}</span>
                      </div>

                      <div className="numbers">
                        {
                          five.map((number, j) => {
                            let predicted = false;

                            try {
                              const wd = winningDraw;
                              const splitted = wd.split(',');

                              for (let i = 0; i < splitted.length; i++) {
                                if (number === parseInt(splitted[i])) {
                                  predicted = true;
                                }
                              }
                            } catch (e) {

                            }

                            return (
                              <span
                                key={j}
                                className={`${predicted ? 'predicted' : ''}`}
                              >
                                {number}
                              </span>
                            );
                          })
                        }
                      </div>
                    </div>
                  );
                })
              }
            </div>

            <div className="success-rate">
              <span>{fives.length} προτεινόμενες στήλες</span>
              <br />
              <br />
              {
                Array.from(Array(5)).map((n, i) => {
                  return (
                    <div>
                      {
                        Array.from(Array(i + 1)).map((num, j) => {
                          return (
                            <span className="number">&nbsp;</span>
                          );
                        })
                      }

                      {
                        Array.from(Array(5 - (i + 1))).map((num, j) => {
                          return (
                            <span>&nbsp;</span>
                          );
                        })
                      }

                      <div className="rate"><b>{successRate[i + 1]}</b> Επιτυχίες</div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>

        <div className={`loading-bar ${simulatingProgress === 0 ? 'hidden' : ''}`}>
          <div className="progress" style={{ width: simulatingProgress + '%' }}>{simulatingProgress}%</div>
        </div>

        <div
          className={`numbers-window ${isNumbersWindowOpen ? '' : 'd-none'}`}
          ref={numbersWindowElRef}
        >
          <div className="content">
            {
              Array.from(Array(45)).map((n, i) => {
                const N = i + 1;

                if (fixedNumbers.indexOf(N) > -1) {
                  return;
                }

                return (
                  <span
                    key={i}
                    onClick={() => {
                      const fnumbers = fixedNumbers;
                      
                      fnumbers[selectedNumber] = N;
                      
                      setFixedNumbers(fnumbers);
                      setFixedNumbersChanged(true);
                      setIsNumbersWindowOpen(false);
                    }}
                  >
                    {N}
                  </span>
                );
              })
            }

            <span
              onClick={() => {
                const fnumbers = fixedNumbers;
                      
                fnumbers[selectedNumber] = -1;
                
                setFixedNumbers(fnumbers);
                setFixedNumbersChanged(true);
                setIsNumbersWindowOpen(false);
              }}
            >
            </span>
          </div>
        </div>

        <div
          className={`console ${showInfo && emulationResult ? '' : 'd-none'}`}
        >
          <button
            className="btn-close"
            onClick={() => {
              setShowInfo(false);
            }}
          >
            Κλείσιμο
          </button>

          {
            emulationResult && fixedNumbers.filter((fnumber) => fnumber > -1).length < 5 && <p>
              {
                fixedNumbers.filter((fnumber) => fnumber > -1).length > 0
                  ? <span>Με {fixedNumbers.filter((fnumber) => fnumber > -1).length} standard αριθμούς</span>
                  : <span>Χωρίς κάποιο standard αριθμό</span>
              }

              {
                parseFloat(emulationResult.successRate.replace(',', '.')) > 0
                  ? <span>, Τα δελτία έχουν ποσοστό επιτυχίας {emulationResult.successRate} ή {emulationResult.successRateAlt}.
                    Ο μέσος όρος δελτίων για κάθε κλήρωση είναι {emulationResult.averagePlays}, και χρειάζονται περίπου {emulationResult.playsUntilWin} για μια πιθανή επιτυχία.</span>
                  : <span>, Δεν σημειώθηκε κάποια επιτυχία. Ο μέσος όρος δελτίων που παίχτηκαν είναι {emulationResult.averagePlays}.</span>
              }
            </p>
          }
        </div>
      </div>

      <div className="tabs">
        <button className={`${tabSelected === 'positions' ? 'active' : ''}`} onClick={() => setTabSelected('positions')}>Θέσεις</button>
        <button className={`${tabSelected === 'fives' ? 'active' : ''}`} onClick={() => setTabSelected('fives')}>Στήλες</button>
      </div>
    </div>
  );
}

export default Dashboard;
